var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hvh-relative w-100"},[_c('HvhChart',{attrs:{"visualization":_vm.visualization,"options":_vm.options,"height":_vm.height},on:{"item-clicked":function($event){return _vm.$emit('item-clicked', $event)}}}),(_vm.isFiltering)?_c('loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }